<template>
  <b-card>
    <b-overlay
      id="overlay-background"
      :show="loader || loader2"
      variant="dark"
      opacity="0.85"
      blur="2px"
      spinner-variant="primary"
      spinner-small
      rounded="sm"
    >
      <debtor-edit-account
        v-if="loader === false && loader2 === false"
        class="mt-2 pt-75"
        :user-data="userData"
        :form-data="formData"
        :clients="clientsObj"
      />
    </b-overlay>
  </b-card>
</template>

<script>
import { BCard, BOverlay } from 'bootstrap-vue'
// import { ref/* , onUnmounted */ } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'
import DebtorEditAccount from './DebtorEditAccount.vue'
import debtorStoreModule from '../debtorStoreModule'

export default {
  components: {
    BCard,
    DebtorEditAccount,
    BOverlay,
  },
  data() {
    return {
      loader: true,
      loader2: true,
      userData: {},
      formData: {},
      address: {
        road_name: null,
        house_number: null,
        place: null,
        zip_code: null,
        city: null,
        country_id: null,
      },
      clientsObj: [],
    }
  },
  created() {
    // const userData = ref(null)
    const USER_APP_STORE_MODULE_NAME = 'app-debtor'
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, debtorStoreModule)

    store.dispatch('app-debtor/fetchDebtor', { id: router.currentRoute.params.id })
      .then(response => {
        this.userData = response.data.data
        this.userData.bankBranchNo = this.userData.bank_branch_no
        this.userData.bankAccountNo = this.userData.bank_account_no
        this.userData.address = this.userData.debtor_address ? this.userData.debtor_address : this.address
        if (this.userData.debtor_address) {
          this.userData.address.house_number = this.userData.debtor_address.house_no
        }
        this.userData.airportOptions = this.userData.airports
        this.formData = { ...response.data }
        this.loader2 = false
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          this.userData = undefined
        }
        if (error.response && error.response.status === 422) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: error.response.data.message,
            },
          })
          this.$router.push('/debtors/list')
        }
      })
    this.clients()
  },
  methods: {
    async clients() {
      this.loader = true
      await axios.get('clients/dropdown')
        .then(response => {
          // console.log(response)
          this.loader = false
          this.clientsObj.push(...response.data.data)
        }).catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
.spinner-border {
  width: 2rem;
  height: 2rem;
}
</style>
